import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { BranchConfigV2 } from '@api/generator';

export interface BranchLimits {
  dailyCutOff: number;
  endOfDay: number;
  toleranceAllowed: number;
  maximumLimit: number;
  permittedLimit: number;
}

export interface BranchInfo {
  branchName: string;
  branchAddress: string;
  fadcode: string;
  isRoyalMailsBranch: boolean;
  branchTypeConfig: BranchConfigV2;
  branchLimits: BranchLimits;
  branchAddressFull: FullBranchAddress;
}

export interface FullBranchAddress {
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  addressLine4?: string;
  addressLine5?: string;
  branchPostcode?: string;
}

export const branchInfoSliceInitialState: BranchInfo = {
  branchName: '',
  branchAddress: '',
  fadcode: '',
  isRoyalMailsBranch: false,
  branchTypeConfig: {
    BPTPUnknownVariance: {
      settlementOptions: [],
      statusBDA: [],
    },
    knownVariance: {
      settlementOptions: [],
      reasonCodes: [],
      knownVarianceReasonCodeUIOptions: [],
    },
    discrepancyAccount: {
      settlementOptions: [],
      status: [],
      autoSettlement: false,
    },
    paidIn: {
      reasonCodes: [],
      paidInReasonCodeUIOptions: [],
    },
    paidOut: {
      reasonCodes: [],
      paidOutReasonCodeUIOptions: [],
    },
    pouchLimitation: 2600000,
    transferLimitation: 10000000,
    branchType: '',
  },
  branchLimits: {
    dailyCutOff: 0,
    endOfDay: 0,
    toleranceAllowed: 0,
    maximumLimit: 0,
    permittedLimit: 0,
  },
  branchAddressFull: {
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    addressLine4: '',
    addressLine5: '',
    branchPostcode: '',
  },
};

export const branchInfoSlice = createSlice({
  name: 'branchInfo',
  initialState: branchInfoSliceInitialState,
  reducers: {
    setBranchInfo(state, action: PayloadAction<Partial<BranchInfo>>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    clearBranchInfo() {
      return branchInfoSliceInitialState;
    },
  },
});

export const { setBranchInfo, clearBranchInfo } = branchInfoSlice.actions;

export default branchInfoSlice.reducer;
